export const gradients = {
  2022: ["#175D85", "#2EC497"],
  2021: ["#BA5DA4", "#D09426"],
  2020: ["#A967CB", "#6EDAE8"],
  2019: ["#2482B4", "#19507E"],
  2018: ["#0AA64C", "#1A6D3E"],
  2017: ["#871B95", "#702C70"],
  2016: ["#B75CA8", "#CE922E"],
};

export const getGradient = (year) => {
  try {
    if (gradients[year]) {
      return gradients[year];
    }

    return gradients["2022"];
  } catch (e) {
    return gradients["2022"];
  }
};
